const translations = {
  en: {
    // Common
    loading: 'Loading...',
    logout: 'Logout',
    back: '← Back',

    // Login page
    passengerPortal: 'Passenger Portal',
    login: 'Login',
    register: 'Register',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    emailAddress: 'Email Address',
    password: 'Password',
    pleaseWait: 'Please wait...',
    createAccount: 'Create Account',
    adminLink: 'Are you a company admin?',
    adminDashboard: 'Admin Dashboard',
    passengerOnlyError: 'This portal is for passengers only.',

    // Search page
    searchTripsHeader: 'Safer — Search Trips',
    points: 'pts',
    myBookings: 'My Bookings',
    findYourTrip: 'Find Your Trip',
    fromCity: 'From (City)',
    toCity: 'To (City)',
    acRequired: '❄️ AC Required',
    wifiRequired: '📶 WiFi Required',
    searchBtn: '🔍 Search',
    searching: 'Searching...',
    noTrips: 'No trips found for this route and date.',
    occupancy: 'Occupancy',
    seatsLeft: 'seats left',
    sarPerSeat: 'ج.س / مقعد',
    bookNow: 'Book Now',
    full: 'Full',

    // Hero / home
    heroTitle: 'Book your trip easily and safely',
    heroSubtitle: 'Search hundreds of daily trips and reserve your seat in seconds',
    passengers: 'Passengers',
    featureAC: 'AC',
    featureWifi: 'WiFi',
    featureChargers: 'Charging Ports',
    featureTV: 'TV',
    featureLuxury: 'Luxury Bus',
    featureMore: 'More',

    // Popular routes
    popularRoutesTitle: 'Popular Destinations',
    popularRoutesSubtitle: 'Frequently traveled routes by our passengers',
    perSeat: 'ج.س',
    dailyDepartures: 'trips/day',
    avgDuration: 'avg. duration',
    from: 'from',
    seeAll: 'See all',

    // Promo banner
    getOffersTitle: 'Get the best deals',
    getOffersText: 'Subscribe now to be the first to know about exclusive offers and discounts',
    subscribeNow: 'Subscribe Now',

    // Trust section
    trustTitle: 'Trusted by travelers across Sudan',
    trustCompanies: 'Trusted Companies',
    trustTrips: 'Trips Daily',
    trustPassengers: 'Happy Travelers',

    // Mobile bottom nav
    navHome: 'Home',
    navMyTrips: 'My Trips',
    navNotifications: 'Notifications',
    navProfile: 'Account',
    navFavorites: 'Favorites',

    // Book page
    bookYourSeat: 'Book Your Seat',
    selectSeats: 'Select Seats',
    available: 'Available',
    selected: 'Selected',
    booked: 'Booked',
    frontOfBus: 'Front of Bus',
    seatsLabel: 'Seats:',
    total: 'Total:',
    continueBtn: 'Continue →',
    selectBankTitle: 'Transfer the amount to the bank account below, then upload your receipt.',
    totalToTransfer: 'Total to transfer:',
    account: 'Account:',
    accountName: 'Name:',
    confirmBooking: 'Confirm Booking →',
    creatingBooking: 'Creating booking...',
    uploadReceiptTitle: 'Upload Payment Receipt',
    bookingCreatedMsg: (num) => `Booking #${num} created!`,
    transferMsg: (amount, bank, accountNum) =>
      `يرجى تحويل ${amount} ج.س إلى ${bank} — رقم الحساب: ${accountNum}، ثم ارفع إيصالك أدناه.`,
    clickToUpload: 'Click to upload receipt (JPG, PNG, PDF)',
    submitReceipt: 'Submit Receipt',
    uploading: 'Uploading...',
    receiptSubmittedTitle: 'Receipt Submitted!',
    bookingNumberLabel: 'Booking Number:',
    awaitingMsg: 'The company will review your receipt and send your ticket via WhatsApp once confirmed.',
    viewMyBookings: 'View My Bookings',
    searchMoreTrips: 'Search More Trips',
    selectBankError: 'Please select a bank account.',
    selectReceiptError: 'Please select a receipt image.',

    // Bookings page
    myBookingsTitle: '🎫 My Bookings',
    searchTripsLink: '← Search Trips',
    noBookings: 'No bookings yet.',
    searchTripsBtn: 'Search Trips',
    seatsDisplay: 'Seats:',
    rejectionReasonLabel: 'Reason:',
    downloadTicket: '📄 Download Ticket',
    cancelBooking: 'Cancel Booking',
    cancelConfirm: 'Cancel this booking?',
    cannotCancel: 'Cannot cancel this booking.',
    downloadFail: 'Failed to download ticket.',

    // Round trip
    oneWay:              'One Way',
    roundTrip:           'Round Trip',
    returnDate:          'Return Date',
    outboundTrip:        '🛫 Outbound',
    returnTripLabel:     '🛬 Return',
    noReturnTrips:       'No return trips found for this date.',
    roundTripTotal:      'Round Trip Total:',
    bookBoth:            '🎫 Book Both Trips',
    bookOutbound:        'Book Outbound',
    bookReturn:          'Book Return',
    sameCompany:         '✓ Same Company',
    differentCompany:    'Different Companies',
    outboundBookedTitle: '✅ Outbound Trip Booked!',
    outboundBookedMsg:   'Your outbound trip is confirmed. Book your return trip now.',
    bookReturnNow:       '🔄 Book Return Trip',
    skipReturn:          'Skip for now',
    roundTripPackage:    'Round Trip Package',

    // Status labels
    status: {
      pending_payment:    'Pending Payment',
      payment_submitted:  'Receipt Submitted',
      payment_confirmed:  'Payment Confirmed',
      payment_rejected:   'Receipt Rejected',
      ticket_issued:      'Ticket Issued ✅',
      cancelled:          'Cancelled',
      completed:          'Completed',
    },
  },

  ar: {
    // Common
    loading: 'جاري التحميل...',
    logout: 'تسجيل الخروج',
    back: 'رجوع →',

    // Login page
    passengerPortal: 'بوابة المسافرين',
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    fullName: 'الاسم الكامل',
    phoneNumber: 'رقم الهاتف',
    emailAddress: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    pleaseWait: 'الرجاء الانتظار...',
    createAccount: 'إنشاء الحساب',
    adminLink: 'هل أنت مدير شركة؟',
    adminDashboard: 'لوحة التحكم',
    passengerOnlyError: 'هذه البوابة للمسافرين فقط.',

    // Search page
    searchTripsHeader: 'سافر — البحث عن رحلات',
    points: 'نقطة',
    myBookings: 'حجوزاتي',
    findYourTrip: 'ابحث عن رحلتك',
    fromCity: 'من (المدينة)',
    toCity: 'إلى (المدينة)',
    acRequired: '❄️ تكييف هواء',
    wifiRequired: '📶 واي فاي',
    searchBtn: '🔍 بحث',
    searching: 'جاري البحث...',
    noTrips: 'لا توجد رحلات لهذا المسار والتاريخ.',
    occupancy: 'نسبة الإشغال',
    seatsLeft: 'مقعد متاح',
    sarPerSeat: 'جنيه / مقعد',
    bookNow: 'احجز الآن',
    full: 'مكتمل',

    // Hero / home
    heroTitle: 'احجز رحلتك بسهولة وأمان',
    heroSubtitle: 'ابحث بين مئات الرحلات اليومية واحجز مقعدك خلال ثوانٍ',
    passengers: 'عدد الركاب',
    featureAC: 'تكييف',
    featureWifi: 'واي فاي',
    featureChargers: 'شواحن',
    featureTV: 'تلفزيون',
    featureLuxury: 'باص فاخر',
    featureMore: 'مزيد',

    // Popular routes
    popularRoutesTitle: 'الوجهات الشائعة',
    popularRoutesSubtitle: 'الوجهات الأكثر طلباً من ركابنا',
    perSeat: 'ج.س',
    dailyDepartures: 'رحلة يومياً',
    avgDuration: 'متوسط المدة',
    from: 'من',
    seeAll: 'عرض الكل',

    // Promo banner
    getOffersTitle: 'احصل على أفضل العروض',
    getOffersText: 'اشترك الآن وكن أول من يعرف بالعروض والخصومات الحصرية',
    subscribeNow: 'اشترك الآن',

    // Trust section
    trustTitle: 'يثق بنا آلاف المسافرين في السودان',
    trustCompanies: 'شركة نقل موثوقة',
    trustTrips: 'رحلة يومياً',
    trustPassengers: 'مسافر سعيد',

    // Mobile bottom nav
    navHome: 'الرئيسية',
    navMyTrips: 'حجوزاتي',
    navNotifications: 'إشعارات',
    navProfile: 'حسابي',
    navFavorites: 'المفضلة',

    // Book page
    bookYourSeat: 'احجز مقعدك',
    selectSeats: 'اختر المقاعد',
    available: 'متاح',
    selected: 'محدد',
    booked: 'محجوز',
    frontOfBus: 'مقدمة الحافلة',
    seatsLabel: 'المقاعد:',
    total: 'الإجمالي:',
    continueBtn: 'متابعة ←',
    selectBankTitle: 'حوّل المبلغ للحساب البنكي ثم ارفع الإيصال في المكان المخصص أدناه',
    totalToTransfer: 'إجمالي التحويل:',
    account: 'رقم الحساب:',
    accountName: 'الاسم:',
    confirmBooking: 'تأكيد الحجز ←',
    creatingBooking: 'جاري إنشاء الحجز...',
    uploadReceiptTitle: 'رفع إيصال الدفع',
    bookingCreatedMsg: (num) => `تم إنشاء الحجز رقم #${num}!`,
    transferMsg: (amount, bank, accountNum) =>
      `يرجى تحويل ${amount} جنيهاً سودانياً إلى ${bank} — الحساب: ${accountNum}، ثم ارفع إيصال التحويل أدناه.`,
    clickToUpload: 'انقر لرفع الإيصال (JPG, PNG, PDF)',
    submitReceipt: 'إرسال الإيصال',
    uploading: 'جاري الرفع...',
    receiptSubmittedTitle: 'تم إرسال الإيصال!',
    bookingNumberLabel: 'رقم الحجز:',
    awaitingMsg: 'ستراجع الشركة إيصالك وستُرسل تذكرتك عبر واتساب بعد التأكيد.',
    viewMyBookings: 'عرض حجوزاتي',
    searchMoreTrips: 'البحث عن رحلات أخرى',
    selectBankError: 'يرجى اختيار حساب بنكي.',
    selectReceiptError: 'يرجى اختيار صورة الإيصال.',

    // Bookings page
    myBookingsTitle: '🎫 حجوزاتي',
    searchTripsLink: 'البحث عن رحلات →',
    noBookings: 'لا توجد حجوزات بعد.',
    searchTripsBtn: 'البحث عن رحلات',
    seatsDisplay: 'المقاعد:',
    rejectionReasonLabel: 'السبب:',
    downloadTicket: '📄 تنزيل التذكرة',
    cancelBooking: 'إلغاء الحجز',
    cancelConfirm: 'هل تريد إلغاء هذا الحجز؟',
    cannotCancel: 'لا يمكن إلغاء هذا الحجز.',
    downloadFail: 'فشل تنزيل التذكرة.',

    // Round trip
    oneWay:              'ذهاب فقط',
    roundTrip:           'ذهاب وإياب',
    returnDate:          'تاريخ العودة',
    outboundTrip:        '🛫 الذهاب',
    returnTripLabel:     '🛬 الإياب',
    noReturnTrips:       'لا توجد رحلات عودة في هذا التاريخ.',
    roundTripTotal:      'إجمالي الذهاب والإياب:',
    bookBoth:            '🎫 احجز ذهاباً وإياباً',
    bookOutbound:        'احجز الذهاب',
    bookReturn:          'احجز الإياب',
    sameCompany:         '✓ نفس الشركة',
    differentCompany:    'شركتان مختلفتان',
    outboundBookedTitle: '✅ تم حجز رحلة الذهاب!',
    outboundBookedMsg:   'تم تأكيد حجز رحلة الذهاب. احجز الآن رحلة العودة.',
    bookReturnNow:       '🔄 احجز رحلة الإياب',
    skipReturn:          'تخطي الآن',
    roundTripPackage:    'باقة الذهاب والإياب',

    // Status labels
    status: {
      pending_payment:    'في انتظار الدفع',
      payment_submitted:  'تم رفع الإيصال',
      payment_confirmed:  'تم تأكيد الدفع',
      payment_rejected:   'تم رفض الإيصال',
      ticket_issued:      'تم إصدار التذكرة ✅',
      cancelled:          'ملغي',
      completed:          'مكتمل',
    },
  },
};

export default translations;
